import { convertToSnakeCase } from "~/Configurators/Shaft/shaftGaHelper";
import type { SummaryData } from "~/Configurators/Shaft/SummaryDataProvider";
import { removeMultipleTags } from "~/utils/domUtils";

export function prepareSummaryDataName(summaryData: SummaryData) {
  let name = summaryData.name?.toString() ?? "";
  name = removeMultipleTags(name, "p", "strong", "sub")!;
  // Remove "(mm)" from the name, even if there are spaces in between
  name = name.replace(/\(\s*mm\s*\)/g, "").trim();
  return convertToSnakeCase(name);
}

export function prepareSummaryDataValue(summaryData: SummaryData) {
  let value = summaryData.value?.toString() ?? "";
  value = removeMultipleTags(value, "p", "strong", "sub")!;
  // Collapse whitespace into a single space
  value = value.replace(/\s+/g, " ").trim();
  return value;
}
